import { connect } from 'react-redux'
import WorkShiftUserRowComponent from '../../components/openforwork/workShiftUserRow.component'
import {
  updateUserWorkshift,
  updateViewWorkshift,
  pinWorkShift,
  saveInvoiceDraft,
  editInvoice,
  getBillableHourUser
} from '../../actions'

const mapStateToProps = (state) => {
  return {
    state,
    saveDraftInvoiceSuccess: state.workShiftUser.saveDraftInvoiceSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    updateUserWorkshift: (values, status) =>
      dispatch(updateUserWorkshift(values, status)),
    updateViewWorkshift: (workshift_itemid) =>
      dispatch(updateViewWorkshift(workshift_itemid)),
    pinWorkShift: (id) => dispatch(pinWorkShift(id)),
    saveInvoiceDraft: (formValues) => dispatch(saveInvoiceDraft(formValues)),
    editInvoice: (formValues) => dispatch(editInvoice(formValues)),
    getBillableHourUser: () => dispatch(getBillableHourUser())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const WorkShiftUserRowContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WorkShiftUserRowComponent)

export default WorkShiftUserRowContainer
